import React from 'react';

function PricingFeature({ features }) {
    return (
        <>
            <ul className="pricing-features">{features}</ul>
        </>
    );
}

export default PricingFeature;
